// extracted by mini-css-extract-plugin
export var alpaquitaForm = "forms-module--alpaquitaForm--449ed";
export var hardenedForm = "forms-module--hardenedForm--74eea";
export var libericaForm = "forms-module--libericaForm--42bb0";
export var libericaSupportForm = "forms-module--libericaSupportForm--27759";
export var nikForm = "forms-module--nikForm--bacb2";